import { render, staticRenderFns } from "./Unidades.vue?vue&type=template&id=2cdb7358&"
import script from "./Unidades.vue?vue&type=script&lang=js&"
export * from "./Unidades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports